import { FC, useEffect, useRef } from 'react';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import type { Invitation } from '@restore/invitationsUserManagement/invitationsUserManagement.types';
import { useInvitationsUserManagementSlice } from '@restore/invitationsUserManagement/invitationsUserManagement.slice';

type RevokeInvitationProps = {
  invitation: Invitation;
  refetchInvitations: () => void;
  onClose: () => void;
};

export const RevokeInvitationModal: FC<RevokeInvitationProps> = ({
  onClose,
  invitation,
  refetchInvitations,
}) => {
  const [revokeInvitation, actionLoading, error] = useInvitationsUserManagementSlice(
    (state, actions) => [actions.revokeInvitation, state.actionLoading, state.error]
  );

  const wasLoadingRef = useRef(false);

  const handleRevoke = () => {
    revokeInvitation(invitation.id);
  };

  useEffect(() => {
    if (wasLoadingRef.current && !actionLoading && !error) {
      refetchInvitations();
      onClose();
    }
    wasLoadingRef.current = actionLoading;
  }, [actionLoading, error, refetchInvitations, onClose]);

  return (
    <Modal
      confirmLoading={actionLoading}
      width={440}
      onCancel={() => onClose()}
      onOk={handleRevoke}
      okText='Revoke'
      centered
      cancelText='Cancel'
      maskClosable={false}
      open={true}
      mask={false}
      okClassName='ant-btn-dangerous'
      classNames={{
        header: 'text-left !mb-3',
        content: 'text-center !rounded-[2.4rem] !p-[4rem]',
        footer: 'flex justify-between !mt-3',
      }}
      title='Revoke invitation'
      titleClassName='text-left'
      okProps={{ disabled: actionLoading }}
      cancelProps={{ disabled: actionLoading }}
      data-testid={'revokeInvitationModal'}
    >
      Are you sure you want to revoke the invitation for{' '}
      <strong>{invitation.invitedEmail}</strong>?
    </Modal>
  );
};
